import React from 'react';
import { func, string } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { useReviewSentiments } from '@thd-nucleus/data-sources';
import { ReviewSentimentModel } from '../../../models/ReviewSentimentModel';
import { Sentiment } from './Sentiment';
import './ReviewSentiments.style.scss';

export const ReviewSentiments = ({ itemId, onSentimentChange, selectedSentiment }) => {

  const { data, error, loading } = useReviewSentiments({ itemId, ssr: false });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const { reviewSentiments } = data;
  const sentimentsModel = new ReviewSentimentModel(reviewSentiments || {});

  if (!sentimentsModel.sentiments.length) {
    return null;
  }
  const { conSentiments, proSentiments } = sentimentsModel;

  return (
    <Row className="ratings-reviews-sentiments">
      <Col xs="6">
        <Sentiment name="Pros" values={proSentiments} selectedSentiment={selectedSentiment} onClick={(sentiment) => onSentimentChange(sentiment)} />
      </Col>
      <Col xs="6">
        <Sentiment name="Cons" values={conSentiments} selectedSentiment={selectedSentiment} onClick={(sentiment) => onSentimentChange(sentiment)} />
      </Col>
    </Row>
  );

};

ReviewSentiments.displayName = 'ReviewSentiments';

ReviewSentiments.propTypes = {
  itemId: string.isRequired,
  onSentimentChange: func.isRequired,
};
